import { Component, OnInit } from '@angular/core';
import { LayoutInitService } from 'src/app/RefModules/_metronic/core';

@Component({
    selector: 'app-organization',
    templateUrl: './organization.component.html',
    styleUrls: ['./organization.component.scss'],
    standalone: false
})
export class OrganizationComponent {
    constructor(private layoutInitService: LayoutInitService) {
        this.layoutInitService.init();
    }
}
